import { css } from 'twin.macro';
import { Form } from 'react-bootstrap';
import Linkify from 'react-linkify';
import { marginColor } from './Checkbox';
import { elementClass, ElementStyled } from './styles/ElementStyles';
import { numberFieldHandler } from '../FormBuilder/FieldProperties/NumberFieldProperties';

const NumberField = ({ data, isPreview, errors, error, elementRef, defaultValue, isDisabled, onChange }) => {
    const { maxValue, minValue } = data?.fieldProperties || {};
    const min = minValue !== undefined && minValue !== '' ? Number(minValue) : undefined;
    const max = maxValue !== undefined && maxValue !== '' ? Number(maxValue) : undefined;
    const registerOptions = {
        required: data.hasOwnProperty('required') ? data.required : true,
        ...(data.validation || {}),
        setValueAs: (inputValue) => {
            if (inputValue === '' || inputValue === null || inputValue === undefined) {
                return inputValue;
            }

            const parsed = Number(inputValue);
            return Number.isNaN(parsed) ? inputValue : parsed;
        },
    };

    if (min !== undefined && !Number.isNaN(min)) {
        registerOptions.min = {
            value: min,
            message: `Minimum value allowed is ${minValue}`,
        };
    }

    if (max !== undefined && !Number.isNaN(max)) {
        registerOptions.max = {
            value: max,
            message: `Maximum value allowed is ${maxValue}`,
        };
    }

    return (
        <ElementStyled
            className={elementClass(data)}
            css={css`
                display: inline-block;
                min-width: max(400px, 50%);
            `}
        >
            <Form.Group controlId={data.name || data._id}>
                <Form.Label
                    css={css`
                        margin-bottom: 0 !important;
                    `}
                >
                    <div className="d-flex flex-row">
                        {data.fieldName}
                        <span css={marginColor}>{(data.hasOwnProperty('required') ? data.required : true) && '*'}</span>
                    </div>
                </Form.Label>

                {data.instruction && (
                    <pre className="small text-muted warpIt preStyles">
                        <Linkify
                            componentDecorator={(decoratedHref, decoratedText, key) => (
                                <a target="blank" href={decoratedHref} key={key}>
                                    {decoratedText}
                                </a>
                            )}
                        >
                            {data.instruction}
                        </Linkify>
                    </pre>
                )}
                <div className="d-flex flex-row justify-content-between">
                    <div style={{ flex: 1 }}>
                        <Form.Control
                            type="number"
                            name={!isPreview ? `NumberField-${data._id}` : 'NumberField'}
                            ref={elementRef && elementRef(registerOptions)}
                            disabled={isPreview || data.isDisabled || isDisabled}
                            defaultValue={data.value ?? data.defaultValue ?? defaultValue ?? ''}
                            placeholder={data.placeholder}
                            onWheel={(e) => e.currentTarget.blur()}
                            onKeyDown={numberFieldHandler.onKeyDown}
                            onPaste={numberFieldHandler.onPaste}
                            onChange={(e) => {
                                const _value = numberFieldHandler.sanitizeValue(e.target.value);
                                if (onChange) onChange(_value);
                            }}
                            min={minValue}
                            max={maxValue}
                        />
                    </div>
                </div>
                <div>
                    {minValue && <span className="badge badge-warning mr-2">Minimum value allowed : {minValue}</span>}
                    {maxValue && <span className="badge badge-warning mr-2">Maximum value allowed : {maxValue}</span>}
                </div>
                <Form.Text className="text-danger">
                    {error && (error.type === 'required' ? error.message || 'This field is required' : error.message)}
                </Form.Text>
            </Form.Group>
        </ElementStyled>
    );
};

export default NumberField;
